import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  padding:160px 20px 100px 20px;
  text-align:center;
  @media (min-width: 480px) {
    padding:160px 40px 100px 40px;
  }
  .HomeContent_Content {
    max-width: 900px;
    margin:0 auto;
    @media (min-width: 768px) {
      padding:20px 70px 60px 70px;
      border:1px solid ${colors.color2};
    }
  }
  .HomeContent-Headline {
    font:900 30px/36px ${typography.SansSerif};
    color:${colors.color1};
    text-transform: uppercase;
    background:white;
    letter-spacing: 2px;
    margin-top: -75px;
    @media (min-width: 768px) {
      margin-top: -85px;
      padding:20px;
      font:900 36px/42px ${typography.SansSerif};
    }
  }
  .HomeContent-Subheading {
    font:italic 300 18px/24px ${typography.SansSerif};
    color:${colors.color2};
    text-transform: capitalize;
    display: block;
    margin-top:10px;
    @media (min-width: 768px) {
      font:italic 300 24px/36px ${typography.SansSerif};
    }
  }
  .HomeContent-Description {
    font:300 16px/24px ${typography.SansSerif};
    color:${colors.color1};
    @media (min-width: 480px) {
      font:300 18px/36px ${typography.SansSerif};
    }
  }
`;

function HomeContent({ page }) {
  return (
    <div className={styles}>
      {
        get(page, 'home_content').map(item => (
          <div key="item.headline" className="HomeContent_Content">
            <h1 className="HomeContent-Headline">
              {get(item, 'headline')}
              <span className="HomeContent-Subheading">{get(item, 'subheading')}</span>
            </h1>
            <div className="HomeContent-Description" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'description'))} />
          </div>
        ))
      }
    </div>
  );
}

HomeContent.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'homepage',
})(HomeContent);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomeContent.js